import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { CommonModule } from '@angular/common';
import { GenericCrudService } from '../../../../../services/generic-crud.service';
import { GenericFormComponent } from '../../../../../shared/components/generic-crud/generic-form/generic-form.component';
import { GenericForm, GenericFormField } from '../../../../../models/GenericCRUD/GenericForm';

@Component({
  selector: 'app-bank-details',
  standalone: true,
  imports: [CommonModule, RouterLink, GenericFormComponent],
  templateUrl: './bank-details.component.html',
  styleUrl: './bank-details.component.css'
})
export class BankDetailsComponent implements OnInit {
  bankId!: number;
  bank: any = null;
  loading: boolean = true;
  editMode: boolean = false;

  formFieldsEdit: GenericFormField[] = [
    { name: 'name', type: 'text', label: 'Nombre del Banco', validations: 'required', colspan: 2 },
    { name: 'code', type: 'text', label: 'Código', validations: '', colspan: 1 },
    { name: 'account_number', type: 'text', label: 'Número de Cuenta', validations: 'required', colspan: 1 },
    { name: 'account_holder', type: 'text', label: 'Titular', validations: '', colspan: 2 },
    { name: 'active', type: 'boolean-switch', label: 'Activo', validations: '', colspan: 2 }
  ];

  editForm!: GenericForm;

  constructor(
    private route: ActivatedRoute,
    private genericCrudService: GenericCrudService
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.bankId = +params['id'];
      this.loadBankDetails();
    });
  }

  loadBankDetails(): void {
    this.loading = true;
    this.genericCrudService.list(`/bank/show/${this.bankId}`).subscribe({
      next: (response) => {
        this.bank = response.data;
        this.loading = false;
      },
      error: (error: any) => {
        console.error('Error al cargar banco:', error);
        this.loading = false;
      }
    });
  }

  toggleEditMode(): void {
    this.editMode = !this.editMode;
    if (this.editMode) {
      this.editForm = {
        method: 'PUT',
        successTitle: 'Banco editado correctamente',
        errorTitle: 'Error al editar banco',
        fields: this.formFieldsEdit,
        name: 'banco',
        createButtonTitle: '',
        cols: 2,
        createApiSlug: '',
        updateApiSlug: `/bank/update/${this.bankId}`,
        formTitle: 'Editar Banco',
        formButtonTitle: 'Guardar cambios',
        width: '3xl'
      };
    }
  }

  onEditFinished(updatedData: any): void {
    if (updatedData) {
      this.bank = updatedData;
    } else {
      this.loadBankDetails();
    }
    this.editMode = false;
  }

  formatCurrency(value: number): string {
    return new Intl.NumberFormat('es-ES', {
      style: 'currency',
      currency: 'EUR'
    }).format(value);
  }
}
